import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
 AfterViewInit,
 Component,
 DestroyRef,
 ElementRef,
 EventEmitter,
 HostListener,
 Inject,
 Input,
 OnDestroy,
 Output,
 PLATFORM_ID,
 QueryList,
 Renderer2,
 ViewChild,
 ViewChildren,
 inject,
 signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatRippleModule } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BehaviorSubject, fromEvent, takeUntil, tap } from 'rxjs';

@Component({
 selector: 'iho-pdp-sticky-tabs',
 standalone: true,
 imports: [CommonModule, MatRippleModule],
 templateUrl: './pdp-sticky-tabs.component.html',
 styleUrls: ['./pdp-sticky-tabs.component.scss'],
})
export class PdpStickyTabsComponent implements AfterViewInit, OnDestroy {
 route = inject(ActivatedRoute);
 destroy$ = new BehaviorSubject<any>('');

 constructor(@Inject(PLATFORM_ID) private platformId: Object) {}
 ngOnDestroy(): void {
  this.destroy$.next('');
  this.destroy$.complete();
 }

 renderer = inject(Renderer2);
 router = inject(Router);
 destroyRef = inject(DestroyRef);

 @ViewChild('activeSymbol', { static: true }) activeSymbol!: ElementRef;
 @ViewChildren('menuItem') menuItems!: QueryList<any>;
 @ViewChild('menuContainer', { static: true }) menuContainer!: ElementRef;

 @Input({ required: true }) accommodation!: string;
 @Input() set scrolledSection(
  tab: { index: number; scrolled?: boolean; fragment?: boolean } | undefined
 ) {
  if (tab?.scrolled) this.activateItem(tab!.index, true, false);
  else if (tab?.fragment) this.activateItem(tab!.index, false, true);
 }

 @Output() selectTab: EventEmitter<number> = new EventEmitter();
 @Output() fragmentTabPending: EventEmitter<any> = new EventEmitter();
 isOnNavBar = false;
 currentIndex = signal(0);

 menuItemsPositions: {
  title: string;
  right: number;
  width: number;
 }[] = [];

 ngAfterViewInit(): void {
  if (isPlatformBrowser(this.platformId)) {
   this.menuItems?.forEach((item: any, _: number) => {
    this.menuItemsPositions.push({
     title: item.nativeElement.classList[7],
     right: item.nativeElement.getBoundingClientRect()?.right,
     width: item.nativeElement.getBoundingClientRect()?.width,
    });
   });
  }
  fromEvent(this.menuContainer.nativeElement, 'mouseover')
   .pipe(
    takeUntilDestroyed(this.destroyRef),

    tap((e) => {
     if (this.isOnNavBar == true) {
      // this.renderer.setStyle(this.document, "overflow", "hidden")
     }
    })
   )
   .subscribe();
 }

 activateItem(index: number, scrolled?: boolean, fragment?: boolean, hover?: boolean) {
  if (isPlatformBrowser(this.platformId)) {
   const menuContainer = this.menuContainer.nativeElement.getBoundingClientRect().right;

   this.renderer.setStyle(
    this.activeSymbol.nativeElement,
    'transform',
    `translateX(${this.menuItemsPositions[index]?.right - menuContainer}px)`
   );
   if (this.menuItems) {
    this.menuItems.forEach((item: ElementRef) => {
     this.renderer.removeClass(item.nativeElement, 'active');
    });
    this.renderer.addClass(this.menuItems.get(index).nativeElement, 'active');

    if (hover) return;

    if (fragment) {
     this.currentIndex.set(index);
     this.selectTab.emit(index);
    }
    if (scrolled) {
     this.currentIndex.set(index);
     this.fragmentTabPending.emit();
    }

    if (!scrolled && !fragment) {
     this.currentIndex.set(index);
     this.selectTab.emit(index);
    }
   }
  }
 }

 updateOnNavBar(event: boolean) {
  if (!event) this.activateItem(this.currentIndex(), false, false, true);
  this.isOnNavBar = event;
 }
}
